<div class="login_bg">
  <!-- Form Section Start -->
  <div class="inner_container">
    <div class="login_form_wrapper">
      <div class="login_form_bg"><a href="login" class="logo" title="ManpowerGroup logo"></a></div>
      <div class="login_form">
        <div class="login_header_right">
          <h1>DirectTime</h1>
        </div>

        <!-- メンテナンス停止中メッセージ -->
        <div *ngIf="isSuspended" class="maintenance_message">
          <p class="maintenance_text">
            ただいまメンテナンスのため<br />システムを停止しています。<br />
            The system is currently down for maintenance.
          </p>
          <p class="maintenance_period">
            {{suspendStartDate}} ～ {{suspendEndDate}}
          </p>
        </div>

      </div>
    </div>
  </div>
  <!-- Form Section End -->

  <!-- Content Section Start -->
  <div *ngIf="notices.length > 0" class="inner_container">
    <div class="login_content_wrapper">
      <ul class="login_content_section">
        <ng-container *ngFor="let notice of notices">
          <li>
            <section>
              <div class="notice_html_content" [innerHTML]="notice.noticeText"></div>
              <p *ngIf="notice.noticeStartDate" class="notice_start_date">{{ notice.noticeStartDate | date:'yyyy-MM-dd' }}</p>
            </section>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <!-- Content Section End -->

</div>